<template>
  <div>
    <login-with-linkedin @handleLogin="login('linkedin')" />
    <login-with-google @handleLogin="login('google')" />
  </div>
</template>

<script>
import LoginWithGoogle from "@/components/auth/LoginWithGoogle.vue";
import LoginWithLinkedin from "@/components/auth/LoginWithLinkedin.vue";

export default {
  name: "SsoLogin",
  components: {
    LoginWithLinkedin,
    LoginWithGoogle
  },
  props: {
    redirectTo: {
      type: String,
      default: "/",
      description: "Path to redirect user once logged in"
    }
  },

  mounted() {
    window.addEventListener("message", this.onMessage, false);

    if (this.$route.query.promptsso === "google") {
      this.login("google");
    }
  },

  beforeDestroy() {
    window.removeEventListener("message", this.onMessage);
  },

  methods: {
    async login(provider) {
      const newWindow = openWindow("", this.$t("sign-in"));

      const url = await this.$store.dispatch("auth/fetchOauthUrl", {
        provider
      });

      newWindow.location.href = url;
    },

    /**
     * @param {MessageEvent} e
     */
    onMessage(e) {
      if (!this.$config.apiUrl.includes(e.origin)) {
        return;
      }

      this.$store.dispatch("auth/saveToken", {
        token: e.data.token
      });

      this.$router.push(this.redirectTo);
    }
  }
};

/**
 * @param  {Object} options
 * @return {Window}
 */
function openWindow(url, title, options = {}) {
  if (typeof url === "object") {
    options = url;
    url = "";
  }

  options = { url, title, width: 600, height: 720, ...options };

  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screen.left;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screen.top;
  const width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    window.screen.width;
  const height =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    window.screen.height;

  options.left = width / 2 - options.width / 2 + dualScreenLeft;
  options.top = height / 2 - options.height / 2 + dualScreenTop;

  const optionsStr = Object.keys(options)
    .reduce((acc, key) => {
      acc.push(`${key}=${options[key]}`);
      return acc;
    }, [])
    .join(",");

  const newWindow = window.open(url, title, optionsStr);

  if (window.focus) {
    newWindow.focus();
  }

  return newWindow;
}
</script>

<style></style>
